import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const scrollToTopAll = () => {
  try {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  } catch (e) {
    window.scrollTo(0, 0);
  }

  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;

  const appEl = document.querySelector(".App");
  if (appEl) appEl.scrollTop = 0;

  const rootEl = document.getElementById("root");
  if (rootEl) rootEl.scrollTop = 0;

  const scrollables = document.querySelectorAll(".App, #root, .holidays-landing-wrapper, html, body");
  scrollables.forEach((el) => {
    if (el) el.scrollTop = 0;
  });
};

export const GoToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    scrollToTopAll();
    const t1 = setTimeout(scrollToTopAll, 50);
    const t2 = setTimeout(scrollToTopAll, 150);
    const t3 = setTimeout(scrollToTopAll, 300);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [pathname, search]);

  return null;
};

